import * as ActionTypes from './actions';
import update from 'immutability-helper';

const paymentProcessors = (state = {}, action) => {
	switch (action.type) {
		case ActionTypes.INIT_PAYMENT_METHOD:
			const currentPaymentMethodState = state[action.payload.paymentMethodName];
			if (!currentPaymentMethodState) {
				return update(state, {
					[action.payload.paymentMethodName]: { $set: action.payload.paymentMethodData }
				});
			}

			return update(state, {
				[action.payload.paymentMethodName]: { $merge: action.payload.paymentMethodData }
			});
		default:
			return state;
	}
};

export default paymentProcessors;